<template lang="pug">
.best-sellings-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='รายการสินค้ายอดนิยม'
          :subtitle='tableData ? `${tableData.length} รายการ`:`...`'
          v-model='filterDate'
        )
      hr.m-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      BestSellingStat(
        :bestSellingsChartData='bestSellingsChartData'
        :totalCommission='totalCommission'
        :total='total'
      )
      .py-2.px-3
        CustomTable(
          :columns='tableColumns'
          :data='tableData'
          :showIndexes='true'
          @itemClicked='showModal'
        )

  modal(
    name='product-group-stat'
    width='640px' height='90%'
    transition='modal-transition'
  )
    ProductGroupStat(
      :customer='customer'
      :productGroup='selectedItem'
      :ranking='selectedItemIndex+1'
      :filterDate='filterDate'
      @closeButtonClicked='hideModal'
    )
    //- SellRecordDetail(
    //-   :customer='customer'
    //-   :sellRecord='selectedItem'
    //-   @closeButtonClicked='hideModal'
    //- )
</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import BestSellingStat from '@/components/history/best-sellings/BestSellingStat.vue';

import ProductGroupStat from '@/components/history/dialogs/BestSellings/ProductGroupStat.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },

  },
  watch: {
    customer() {
      this.loadData();
    },

    // reload data
    filterDate: {
      handler() { this.loadData(); },
      deep: true,
    },
    // currentPage() { this.loadData(); },
  },
  data: () => ({
    isLoading: false,
    filterDate: '', // default value will be set in mounted()

    tableColumns: {
      group_id: {
        title: 'กลุ่ม',
        align: 'center',
      },
      name: {
        title: 'ชื่อ',
        align: 'left',
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
    },

    tableData: [],
    bestSellingsChartData: [],
    total: 0,
    totalCommission: 0,

    selectedItem: {},
    selectedItemIndex: -1,
  }),
  methods: {
    async loadData() {
      this.isLoading = true;

      try {
        const res = await this.$api.customer.history.bestSellings(
          this.customer.id,
          this.filterDate.from,
          this.filterDate.to,
        );

        if (res.status === 200) {
          // preprocess data
          let total = 0;
          let totalCommission = 0;
          const byGroup = {};

          res.data.best_sellers.forEach((elm) => {
            const strPad = `00${elm.group_id}`;
            const groupName = strPad.substring(strPad.length - 2, strPad.length);
            if (!(groupName in byGroup)) byGroup[groupName] = [];
            byGroup[groupName].push(elm);

            // calculate total
            total += parseFloat(elm.total);
            totalCommission += parseFloat(elm.total_commission);
          });

          // organize into groups
          const byGroupTable = [];
          Object.keys(byGroup).forEach((key) => {
            const obj = { group_id: key, name: key, total: 0 }; // TODO: find group name
            byGroup[key].forEach((elm) => {
              obj.name = elm.group_name;
              obj.total += parseFloat(elm.total);
              obj.items = byGroup[key];
            });
            byGroupTable.push(obj);
          });

          console.log(byGroupTable);
          this.total = total;
          this.totalCommission = totalCommission;
          this.tableData = byGroupTable;

          this.bestSellingsChartData = byGroupTable.map(elm => ({
            group: elm.group_id,
            value: elm.total,
          }));
        }
        console.log(this.bestSellingsChartData);

        this.isLoading = false;
      } catch (e) {
        this.tableData = null;
        this.bestSellingsChartData = null;
        console.log(e);
      }
    },
    showModal(e) {
      this.selectedItemIndex = e.index;
      this.selectedItem = this.tableData[this.selectedItemIndex];
      this.$modal.show('product-group-stat');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('product-group-stat');
    },
  },
  mounted() {
    this.loadData();

    // this.filterDate = {
    //   from: this.$moment().startOf('day').toDate(),
    //   to: this.$moment().startOf('day').toDate(),
    // };
  },
  components: {
    CustomerCompactDetailHeader,
    BestSellingStat,

    ProductGroupStat,
  },
};
</script>

<style lang="scss">
.best-sellings-list {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
